import _extends from "@babel/runtime-corejs3/helpers/extends";
import React from 'react';
import AntRadio, { Group, Button } from 'antd/lib/radio';
var InternalRadio = /*#__PURE__*/React.memo(props => {
  return /*#__PURE__*/React.createElement(AntRadio, _extends({
    className: "sk-radio-wrapper"
  }, props));
});
var Radio = InternalRadio;
Radio.Group = Group;
Radio.Button = Button;
export { Group, Button };
export default Radio;